<material-navbar 
  [container]="true" 
  [menuPosition]="settings.get('vebto.navbar.defaultPosition', 'homepage-navbar')" 
  class="login-button-accent"
>
  <div class="fab-container">
    <div class="fab shadow">
      <div class="fab-content">
        <i class="fa fa-comments-o" aria-hidden="true"></i>
      </div>
    </div>
    <div class="sub-button shadow">
      <a href="https://ig.me/m/jioshurl" target="_blank">
        <i class="fa fa-instagram" aria-hidden="true"></i>
      </a>
    </div>
    <div class="sub-button shadow">
      <a href="https://m.me/JioShURL" target="_blank">
        <i class="fa fa-facebook" aria-hidden="true"></i>
      </a>
    </div>
    <div class="sub-button shadow">
      <a href="https://twitter.com/messages/compose?recipient_id=1410639908738244612&text=Hi" target="_blank">
        <i class="fa fa-twitter" aria-hidden="true"></i>
      </a>
    </div>
    <div class="sub-button shadow">
      <a href="https://t.me/JioShURLBot" target="_blank">
        <i class="fa fa-telegram" aria-hidden="true"></i>
      </a>
    </div>
    <div class="sub-button shadow">
      <a href="https://api.whatsapp.com/send/?phone=917276595716&text=Hi&type=phone_number&app_absent=0"
        target="_blank">
        <i class="fa fa-whatsapp" aria-hidden="true"></i>
      </a>
    </div>
  </div>
</material-navbar>

<div class="hero header-overlay" style="background: #546ef9">
  <div class="background-image" [style.background-image]="'url(' + content.headerImage + ')'"
    [style.opacity]="content.headerImageOpacity"></div>
  <svg viewBox="0 0 100 15" style="position: absolute; bottom: 0; left: 0; z-index: 2">
    <path fill="#fff" opacity="0.1" d="M0 30 V15 Q30 3 60 15 V30z"></path>
    <path class="wave-fill" d="M0 30 V12 Q30 17 55 12 T100 11 V30z"></path>
  </svg>
  <div class="hero-content">
    <div class="container main-head">
      <div class="main-below">
        <div class="headd">
          <h1 class="header-title" trans>Abuse report</h1>
          <p class="header-description" trans>Report the suspicious link</p>
          <abuse-report-form>
          </abuse-report-form>
          <div class="action-buttons">
            <a
              class="get-started-button"
              mat-raised-button
              color="accent"
              (click)="handleCtaClick($event, content.actions.cta1, router)"
              [href]="content.actions.cta1.action"
              *ngIf="content?.actions?.cta2?.label"
              trans
              >{{ content.actions.cta1.label }}</a
            >
            <button
              class="learn-more-button"
              mat-button
              (click)="handleCtaClick($event, content.actions.cta2, router)"
              *ngIf="content?.actions?.cta2?.label"
              trans
            >
              {{ content.actions.cta2.label }}
            </button>
          </div>
        </div>
        <div>
          <img
            class="display-none"
            src="/client/assets/images/homehead-removebg-preview.png"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="container center url-head-div"
>
  <!-- <div><h1 class="url-shortener">URL Shortener & Bio Link Builder</h1></div> -->
  <div><h1 class="url-shortener">Reporting Suspicious Link</h1></div>
  <p class="bottom-txt">
    At JioSh URL, our commitment to user safety and security is paramount. We appreciate your cooperation in using our reporting feature responsibly and trust that together, we can maintain a secure and positive experience for all users.
  </p>
  <p class="bottom-txt">
    Should you encounter any instances of abuse or come across suspicious links within the JioSh URL domain, we strongly encourage you to utilize our reporting feature. By reporting such links, you contribute to the ongoing effort to preserve the integrity and security of our platform.
  </p>
  <p class="bottom-txt">
    Please only report links that belong to JioSh URL. Our reporting system is designed to handle issues specifically related to JioSh URL links. Reporting other types of links may not be within our ability to address. Thank you for your understanding and cooperation.
  </p>
  <!-- <p class="bottom-txt">
    JioSh URL is a URL shortener & Bio Link Builder - a great tool for easily
    managing short links & Bio Links. With JioSh, you can create short, branded
    links that support the development of your brand and your business. Bio
    Links are a cool feature that allows you to explore different aspects of
    your website.<br />
    <span style="font-weight: bold"
      >So why wait? Click the button below to Sign Up / Login now!</span
    >
  </p>
  <div class="bottom-btns">
    <a class="btn" [routerLink]="['/login']" mat-flat-button>
      Login
    </a>
    <a class="btn" [routerLink]="['/register']" mat-flat-button>
      Sign Up
    </a>
  </div> -->
</div>

<app-footer class="container"></app-footer>